export const config = {
  port: 4100,
  appFolder: 'dist/apps/printer-app',
  windowDataKey: 'isophiData'
};
